/**
 * Email Service calling the local backend proxy via Vite Proxy
 */
export const sendOTPExmail = async (email, code) => {
  try {
    // Apelăm endpoint-ul relativ pentru a folosi proxy-ul din vite.config.js
    const response = await fetch('/api/send-otp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, code }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error?.message || 'Failed to send email');
    }

    return { success: true, data };
  } catch (error) {
    console.error('Email Service Error:', error);
    return { 
      success: false, 
      error: error.message,
      isCorsError: false
    };
  }
};